"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'settings.credit.description': '配置AI服务的积分转换率',
    'settings.credit.failedToLoad': '积分设置加载失败',
    'settings.credit.savedSuccessfully': '积分设置保存成功',
    'settings.credit.failedToSave': '积分设置保存失败',
    'settings.credit.save': '保存积分设置',
    'settings.credit.reload': '重新加载',
    'settings.credit.credits': '积分',
    'settings.credit.conversion.title': '货币转换',
    'settings.credit.conversion.dollarToCreditRate': '每美元积分数',
    'settings.credit.conversion.dollarToCreditRate.help': '1美元等于多少积分。这会影响所有AI操作的定价。',
    'settings.credit.preview.title': '转换预览',
    'settings.credit.warning.title': '重要提示',
    'settings.credit.warning.description': '积分汇率的更改将影响所有未来的AI操作。现有用户积分不会受到影响。',
};
